import React from 'react';
import { Col, Container, Input, Label, Row } from 'reactstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import Select from 'react-select';
import { mustBeArray } from '../../utils/lib';

const RebatesRCTIListFilters = props => {
    const {handleFilterChange, filters, statusOptions, handleCreate, handleResetFilter, 
            handleSearch, statusList} = props;
    return(
        <Container>
            <Row className="align-items-center mb-1">
                <Col sm={4} md={3}>
                    <Label for="clientName">Client Name</Label>
                </Col>
                <Col sm={8} md={9}>
                    <Input 
                        id="clientName"
                        value={filters.clientName}
                        onChange={e => handleFilterChange({value: e.target.value, field: "clientName"})}
                        placeholder="Name"
                    />
                </Col>
            </Row>
            <Row className="align-items-center full-width-datepicker">
                <Col sm={4} md={3} >
                    <Label for="from" >From</Label>
                </Col>
                <Col sm={8} md={4} className="mb-1">
                    <DatePicker
                        onChange={(date) => handleFilterChange({value: date, field: 'dateFrom'})}
                        value={filters.dateFrom || undefined}
                        openToDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
                        placeholderText="Date From"
                        locale="en-au"
                        readOnly={false}
                        popperPlacement="bottom-end"
                        popperModifiers={{
                        offset: {
                            enabled: true,
                            offset: '5px, 10px'
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                            boundariesElement: 'viewport'
                        }
                        }}
                        className="form-control"
                    />
                </Col>
                <Col sm={4} md={1}>
                    <Label for="to" >To</Label>
                </Col>
                <Col sm={8} md={4} className="mb-1">
                    <DatePicker
                        onChange={(date) => handleFilterChange({value: date, field: 'dateTo'})}
                        value={filters.dateTo || undefined}
                        openToDate={filters.dateTo ? moment(filters.dateTo) : moment()}
                        placeholderText="Date To"
                        locale="en-au"
                        readOnly={false}
                        popperPlacement="bottom-end"
                        popperModifiers={{
                        offset: {
                            enabled: true,
                            offset: '5px, 10px'
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                            boundariesElement: 'viewport'
                        }
                        }}
                        className="form-control"
                        minDate={filters.dateFrom ? moment(filters.dateFrom) : moment()}
                    />
                </Col>
            </Row>
            <Row className="align-items-center mb-1" >
                <Col sm={4} md={3}>
                    <Label for="statusID">Status</Label>
                </Col>
                <Col sm={8} md={9}>
                    <Select
                        name="statusID"
                        value={filters.statusID}
                        multi={false}
                        clearable={false}
                        simpleValue={true}
                        options={mustBeArray(statusList)}
                        onChange={(value) => handleFilterChange({value, field: "statusID"})}
                        valueKey="id"
                        labelKey="name"
                    />
                </Col>
            </Row>
            <div className="mt-2">
                <button className="btn btn-primary" onClick={handleSearch}>
                    <i className="fa fa-search" aria-hidden="true"></i> &nbsp;Search
                </button>
                <button className="btn btn-default ml-1" onClick={handleResetFilter}>Reset</button>
                <button className="btn btn-success ml-1 bold" onClick={handleCreate}> 
                    <i className="fa fa-plus" aria-hidden="true"></i> &nbsp;New RCTI
                </button>
            </div>
        </Container>
    );
};
export default RebatesRCTIListFilters;